import { formatter } from 'components/atoms/input-duration';
import { FieldType, FilterableField } from 'components/organisms/tasks/fields';
import { getValueFormatter as getValueFormatterBase } from 'components/organisms/tasks/renderers';
import { ProjectTimeTrackingFieldsName as FieldNames } from 'utils/project-fields/use-project-native-fields-as-filterable-fields';
import { ProjectFieldsName } from '../fields';

export const getValueFormatter = (field: FilterableField) => {
  switch (field.type) {
    case FieldType.Number:
      switch (field.fieldName) {
        case ProjectFieldsName.arr:
        case ProjectFieldsName.projectFee:
          return ({ value }) => (value == null ? '-' : `$${value}`);
        case ProjectFieldsName.projectAge:
          return ({ value }) =>
            value == null ? '-' : value === 0 ? '1d' : `${value}d`;
        case ProjectFieldsName.plannedDuration:
          return ({ value }) => (value == null ? '-' : `${value}d`);
        case FieldNames.allocatedHours:
          return ({ value }) =>
            value == null ? '-' : `${(value as number)?.toFixed(2) ?? 0}h`;
        case FieldNames.budgetedHours:
        case FieldNames.trackedHours:
          return ({ value }) => {
            return formatter(value);
          };
        default:
          return getValueFormatterBase(field);
      }
    default:
      return getValueFormatterBase(field);
  }
};
